var _path, _path2, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuoteCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.09 55.661V23.992h8.392m35.765 25.275L41.962 23.992h-20.48m35.765 25.275v10.99m0-10.99H30.872m0 0v-19.28m0 19.28h-9.39V23.992M5.098 72.345V55.761h35.765l9.19 8.392M22.88 79.938h27.774",
    stroke: "#2E5ECC",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.459 79.837c.372-3.286.337-4.91.999-7.293 2.205-7.932 8.41-13.233 17.083-12.387 2.579.251 4.655 1.179 8.092 2.098M58.645 16h5.594m0 0h6.394v35.166M64.239 16v35.166m0 8.99v-8.99m6.394 18.582V51.166m0 0h-6.394m6.394 0h6.394v30.57H104",
    stroke: "#2E5ECC",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.189,
    cy: 78.439,
    r: 9.189,
    stroke: "#2E5ECC",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.541,
    cy: 76.841,
    r: 10.787,
    stroke: "#2E5ECC",
    strokeWidth: 4
  })));
}

export default SvgQuoteCar;